import { cx } from 'class-variance-authority'
import { InformationCircleIcon } from '@heroicons/react/24/solid'

import type { PropsWithChildren } from '../../types'

function InfoGraphic({
  children,
  color = 'light',
}: PropsWithChildren<{ color?: 'dark' | 'light' }>) {
  return (
    <div className="flex items-center gap-2">
      <InformationCircleIcon
        className={cx([
          color === 'dark'
            ? 'text-ion-color-primary'
            : 'text-ion-color-secondary',
          'size-5 flex-shrink-0',
        ])}
      />
      <div className="italic leading-none">{children}</div>
    </div>
  )
}

export { InfoGraphic }
